import { Injectable } from "@angular/core";
import { MonthTimetable, TestEvent } from "../models/event.model";

@Injectable({ providedIn: "root" })
export class TimetableService {
  private timetableData: MonthTimetable = {
    Online: [
      {
        date: "",
        name: "CSSE01",
        description: "Maths, Eng Reading Comp. & Creative Writing",
        testtype: "1st CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "09:00 AM - 06:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/3210adcfc8bad1f1e08b2b66ddd57589",
          },
        ],
      },

      {
        date: "",
        name: "GLBU01",
        testtype: "BUCKS, GL Assessment 01",
        description:
          "Maths, Eng, Verbal Reasoning(VR), Non Verbal Reasoning(NVR)",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/c32acfd4673374894bc7702d24d17f19",
          },
        ],
      },

      {
        date: "",
        name: "GLBR01",
        testtype: "1st GL Asessment, Redbridge",
        description:
          "Maths, Eng, Verbal Reasoning(VR), Non Verbal Reasoning(NVR)",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/d681e62123ab44dc1d1b3bc1171ed145",
          },
        ],
      },
      {
        date: "",
        name: "GLKE01",
        description: "Maths, English, VR, NVR",
        testtype: "1st GL Asessment, Kent",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/9ad59933748205a1866885ad6a2ba7a4",
          },
        ],
      },

      {
        date: "",
        name: "FSCE01",
        description: "Maths, Eng, Creative Writing",
        testtype: "1st FSCE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/8316c033717ac65d7af08d30e45fc32c",
          },
        ],
      },
      {
        date: "",
        name: "GLQE01",
        description: "Maths, Eng, Verbal Reasoning(VR)",
        testtype: "1st GL Asessment, QE Barnet",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/0004a003f9de95f93e8c7f80e83faf5f",
          },
        ],
      },
      {
        date: "",
        name: "GLHBS01",
        description: "Maths, Eng, VR, NVR",
        testtype: "1st GL Asessment, HBS",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/352f4cc199a562c56aabac3a5ed95e4b",
          },
        ],
      },

      {
        date: "",
        name: "CSSE02",
        description: "Maths, Eng, Comp., VR, Creative Writing",
        testtype: "2nd CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/2f441ba76acd2cb42263ded7968721c4",
          },
        ],
      },

      {
        date: "",
        name: "GLBU02",
        description: "Maths, Eng, VR, NVR",
        testtype: "BUCKS, GL Assessment 02",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/dd30d960a6a46d7749041ab9b9f7818f",
          },
        ],
      },
      {
        date: "",
        name: "GLRB02",
        description: "Maths, Eng, VR, NVR",
        testtype: "2nd GL Asessment, Redbridge",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/8ec437821df73578e7cc6f9a44eef8b9",
          },
        ],
      },
      {
        date: "",
        name: "GLKE02",
        description: "Maths, Eng, VR, NVR",
        testtype: "2nd GL Asessment, Kent",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/28042dd037f39e46e52eb34e90b6f942",
          },
        ],
      },

      {
        date: "",
        name: "CSSE03",
        description: "Maths, Eng, VR, NVR",
        testtype: "3rd CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/9930536a969799c04cd80acd0f654dd5",
          },
        ],
      },

      {
        date: "",
        name: "FSCE02",
        description: "Maths, Eng, Creative Writing",
        testtype: "2nd FSCE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/44a912b16317692998067b5f4ea63a67",
          },
        ],
      },
      {
        date: "",
        name: "GLQE02",
        description: "Maths, English, VR",
        testtype: "2nd GL Asessment, QE Barnet",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/b4a472b18331e36836e0eedce36dc719",
          },
        ],
      },
      {
        date: "",
        name: "GLHBS02",
        description: "Maths, Eng, VR, NVR",
        testtype: "2nd GL Asessment, HBS",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/fc3d52598d472fc7141e88ff2625ab61",
          },
        ],
      },

      {
        date: "",
        name: "CSSE04",
        description: "Maths, Eng, Comp, VR, Creative Writing",
        testtype: "4th CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/a92c0dca871798ebdb821dd1f80f95a5",
          },
        ],
      },

      {
        date: "",
        name: "GLBU03",
        description: "Maths, Eng, VR, NVR",
        testtype: "BUCKS, GL Assessment 03",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/dda5fc5f97d967aa8f38c767b76ee6f5",
          },
        ],
      },

      {
        date: "",
        name: "GLRB03",
        description: "Maths, Eng, VR, NVR",
        testtype: "3rd GL Asessment, Redbridge",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/69e9a2e35d56e41d7c7dbba2fb0a025b",
          },
        ],
      },
      {
        date: "",
        name: "GLKE03",
        description: "Maths, Eng, VR, NVR",
        testtype: "3rd GL Asessment, Kent",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/1168b2d161bb0b64716208e66ce67025",
          },
        ],
      },

      {
        date: "",
        name: "CSSE05",
        description: "Maths, English, Comp VR, Creative Writing",
        testtype: "5th CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/90f6668f132d31f80e5b58674dd73722",
          },
        ],
      },
      {
        date: "",
        name: "FSCE03",
        description: "Maths, Eng, Creative Writing",
        testtype: "3rd FSCE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLQE03",
        description: "Maths, English, VR",
        testtype: "3rd GL Asessment, QE Barnet",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLHBS03",
        description: "Maths, Eng, VR, NVR",
        testtype: "3rd GL Asessment, HBS",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "CSSE06",
        description: "Maths, Eng, Comp, VR, Creative Writing",
        testtype: "6th CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLRB04",
        description: "Maths, Eng, VR, NVR",
        testtype: "4th GL Asessment, Redbridge",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLKE04",
        description: "Maths, Eng, VR, NVR",
        testtype: "4th GL Asessment, Kent",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "CSSE07",
        description: "Maths, English, Comp VR, Creative Writing",
        testtype: "7th CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "FSCE04",
        description: "Maths, English, Creative Writing",
        testtype: "4th FSCE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLQE04",
        description: "Maths, English, VR",
        testtype: "4th GL Asessment, QE Barnet",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLHBS04",
        description: "Maths, English, VR, NVR",
        testtype: "4th GL Asessment, HBS",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },

      {
        date: "",
        name: "CSSE08",
        description: "Maths, Eng, Comp, VR, Creative Writing",
        testtype: "8th CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLRB05",
        description: "Maths, English, VR, NVR",
        testtype: "5th GL Asessment, Redbridge",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLKE05",
        description: "Maths, Eng, VR, NVR",
        testtype: "5th GL Asessment, Kent",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "SET01",
        description: "SUTTON 1",
        testtype: "Sutton1",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "CSSE09",
        description: "Maths, Eng, Comp, VR, Cretive Writing",
        testtype: "9th CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLQE05",
        description: "Maths, Eng, VR, NVR",
        testtype: "5th GL Asessment, QE Barnet",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLHBS05",
        description: "Maths, English, Comp VR, Creative Writing",
        testtype: "5th GL Asessment, HBS",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "FSCEO5",
        description: "Maths, English, Creative Writing",
        testtype: "5th FSCE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },

      {
        date: "",
        name: "CSSE10",
        description: "Maths, Eng, Comp, VR, Creative Writing",
        testtype: "10th CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLRB06",
        description: "Maths, English, VR, NVR",
        testtype: "6th GL Asessment (Essex/Redbridge)",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLKE06",
        description: "Maths, Eng, VR, NVR",
        testtype: "6th GL Asessment Kent",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "SET02",
        description: "SUTTON 2",
        testtype: "Sutton 2",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "FSCE06",
        description: "Maths, Engish, Cretive Writing",
        testtype: "6th FSCE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLQE06",
        description: "Maths, Eng, VR",
        testtype: "6th GL Asessment, QE Barnet",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLHBS06",
        description: "Maths, English, VR, NVR",
        testtype: "6th GL Asessment, HBS",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "CSSE11",
        description: "Maths, English, Comp, VR, Creative Writing",
        testtype: "11th CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
      {
        date: "",
        name: "GLRB07",
        description: "Maths, English, VR, NVR",
        testtype: "7th GL Asessment (Essex/Redbridge)",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },

      {
        date: "",
        name: "CSSE12",
        description: "Maths, Eng, Comp, VR, Creative Writing",
        testtype: "12th CSSE Style 11+ Mock Test",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test",
          },
        ],
      },
    ],
  };

  getMonths(): string[] {
    return ["Online"];
  }

  getTimetable(): MonthTimetable {
    return this.timetableData;
  }
}
